import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncFlagWithCommentModal = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-flag-with-comment-modal" */ './src/ui').then(
			(module) => module.CommentOnFlaggingUnflaggingEntryPoint,
		),
	),
	getPreloadProps: () => ({}),
});
